import React, { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Box, Alert, Button } from "@mui/material";
import ArrowBack from '@mui/icons-material/ArrowBack';
import TemplateEditor from "../components/researcher/TemplateEditor";

/**
 * Template Editor Page
 * Standalone page for managing contact message templates
 */

const TemplateEditorPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const studyId = useMemo(() => searchParams.get("study"), [searchParams]);

  if (!studyId) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error">
          Study ID is required. Please open this page from your dashboard.
        </Alert>
      </Container>
    );
  }

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", py: 2 }}>
      <Container maxWidth="lg">
        <Button startIcon={<ArrowBack />} onClick={() => navigate(`/researcher/preferences?study=${encodeURIComponent(studyId)}`)}>Back to preferences</Button>
        <TemplateEditor studyId={studyId} onClose={() => navigate(`/researcher/preferences?study=${encodeURIComponent(studyId)}`)} />
      </Container>
    </Box>
  );
};

export default TemplateEditorPage;
